export const roundNumber = (num, count = 10) => {
    if (isNaN(+num)) {
        return num;
    }

    return Math.trunc(num * count) / count;
};
